import { render, staticRenderFns } from "./TableInscribir.vue?vue&type=template&id=1cc3236c&scoped=true"
import script from "./TableInscribir.vue?vue&type=script&lang=js"
export * from "./TableInscribir.vue?vue&type=script&lang=js"
import style0 from "./TableInscribir.vue?vue&type=style&index=0&id=1cc3236c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc3236c",
  null
  
)

export default component.exports